import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import { t } from "../../i18n";
import AnimatedSection from "../AnimatedSection/AnimatedSection";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import styles from "./TestimonialSection.module.scss";
const testimonials = [
  {
    companyLogo: "/images/lcw.png",
    avatar: "/images/lcw-testimonial2.jpeg",
    name: "Barış K.",
    position: t("testimonialsSection.position1"),
    comment: t("testimonialsSection.comment1"),
  },
  {
    companyLogo: "/images/drd.png",
    avatar: "/images/neclaCelik.jpeg",
    name: "Necla Ç.",
    position: t("testimonialsSection.position2"),
    comment: t("testimonialsSection.comment2"),
  },
  {
    companyLogo: "/images/teknosin.png",
    avatar: "/images/idilYagli.jpg",
    name: "İdil Y.",
    position: t("testimonialsSection.position3"),
    comment: t("testimonialsSection.comment3"),
  },
];

const TestimonialsSection: React.FC = () => {
  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);
  const [isSwiperReady, setIsSwiperReady] = useState(false);

  useEffect(() => {
    setIsSwiperReady(true);
  }, []);

  return (
    <section className="py-20 px-4 sm:px-6">
      <AnimatedSection>
        <div className="max-w-4xl mx-auto text-center mb-10">
          <h2 className="text-4xl font-bold text-gray-800">{t("testimonialsSection.title")}</h2>
          <p className="text-lg text-gray-600 mt-2">{t("testimonialsSection.subtitle")}</p>
        </div>
      </AnimatedSection>

      <AnimatedSection delay={200}>
        <div className="max-w-7xl mx-auto relative">
          {isSwiperReady && (
            <Swiper
              className={`${styles.styledSwiper} relative rounded-xl w-full max-w-6xl mx-auto`}
              modules={[Navigation, Autoplay, Pagination]}
              slidesPerView={1}
              autoplay={{ delay: 6000 }}
              loop
              navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
              pagination={{ clickable: true }}
              onBeforeInit={(swiper: SwiperType) => {
                if (typeof swiper.params.navigation !== "boolean" && swiper.params.navigation) {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }
              }}
              onSwiper={(swiper: SwiperType) => {
                const el = (swiper.pagination && (swiper.pagination as any).el) as HTMLElement | undefined;
                if (el) {
                  el.classList.add("absolute", "bottom-4", "inset-x-0", "z-10", "flex", "justify-center");
                }
              }}
            >
              {testimonials.map((tItem, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="rounded-xl py-10 md:py-20 px-4 sm:px-10 flex flex-col md:flex-row justify-between gap-10 md:gap-28 bg-cover bg-center bg-no-repeat relative w-full h-[400px] md:h-[500px]"
                    style={{ backgroundImage: "url(/images/customer_bg.jpg)" }}
                  >
                    <div className="absolute inset-0 bg-cover bg-center bg-no-repeat rounded-xl" style={{ backgroundImage: "url(/images/customer_bg.jpg)" }} />
                    <div className="relative z-10 w-full h-full">
                      <div className="bg-black bg-opacity-50 backdrop-blur-sm rounded-lg p-4 md:p-6 text-left w-full max-w-xl">
                        <p className="text-white text-sm md:text-base lg:text-lg !leading-relaxed overflow-hidden">“{tItem.comment}”</p>
                      </div>
                      <div className="absolute bottom-0 right-0 flex flex-row items-center gap-3 md:gap-4">
                        <img
                          src={tItem.avatar}
                          alt={tItem.name}
                          className="h-[120px] sm:h-[150px] md:h-[180px] w-[100px] sm:w-[120px] md:w-[140px] object-cover rounded-xl shadow-md"
                        />
                        <div className="bg-black bg-opacity-50 backdrop-blur-sm rounded-lg p-2 md:p-3 text-center w-32 sm:w-40 md:w-48">
                          <div className="text-sm sm:text-base md:text-lg font-semibold text-white mb-1">{tItem.name}</div>
                          <div className="text-xs sm:text-sm md:text-base text-gray-200 mb-1 md:mb-2">{tItem.position}</div>
                          <div className="bg-[#dbdbdb] rounded-lg p-2">
                            <img src={tItem.companyLogo} alt="Şirket Logosu" className="w-12 sm:w-16 md:w-20 h-auto object-contain mx-auto" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </AnimatedSection>
    </section>
  );
};

export default TestimonialsSection;
